export { EventTypes } from './registry.js'
export type { EventType, EventPayloadMap } from './registry.js'

/**
 * Fire-and-forget structured event logger.
 * No queue, no retry, no local state — minimal memory footprint.
 */
export function logEvent(
  apiBase: string,
  authToken: string,
  event: string,
  payload: Record<string, unknown> = {},
): void {
  void fetch(`${apiBase}/staff/events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authToken}` },
    body: JSON.stringify({ event, payload }),
  }).catch(() => undefined)
}
